export default "__VITE_ASSET__Cr96lAk4__"